import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './EduBotItem.module.css'
import { Button, Divider, Flex, message, Tooltip } from 'antd'
import classNames from 'classnames'
import userIcon from './userIcon.svg'
import shareImgIcon from './shareImg.svg'
export default function EduBotItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  return (
    <div
      className={classNames(
        styles.background,
        props.index % 4 != 0 ? styles.marginLeft : '',
        parseInt(props.index / 4) > 0 ? styles.marginTop : '',
      )}
      onClick={props.clickBotItem.bind(null, props.info)}
    >
      <div className={styles.TopBox}>
        <img className={styles.headerImg} src={props.info.icon_url} alt="" />
        <Tooltip placement="bottom" title={props.info.bot_name}>
          <div className={styles.botName}>{props.info.bot_name}</div>
        </Tooltip>
        {/* <img className={styles.questionIcon} src={props.info.question_icon_url} alt="" /> */}
      </div>
      <Tooltip placement="bottom" title={props.info.description}>
        <div className={styles.middleContainer}>{props.info.description}</div>
      </Tooltip>
      <div className={styles.bottomContainer}>
        <img
          className={styles.shareImg}
          src={shareImgIcon}
          alt=""
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            props.shareBotItem(props.info)
          }}
        />
        <div className={styles.rightContainer}>
          <div className={styles.timeContainer}>
            <img className={styles.userIcon} src={userIcon} alt="" />
            <span>{props.info.open_time}</span>
          </div>
          <div className={styles.nameBox}>@{props.info.name}</div>
        </div>
      </div>
    </div>
  )
}
